export const MODULE_NAME = 'store';
export const MODULE_ID = `tini:${MODULE_NAME}`;
//# sourceMappingURL=consts.js.map